import { Helmet } from "react-helmet";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import CareerFormSection from "./CareerFormSection";
import CareerSection from "./CareerSection";
import React from "react";

export default function CareerPage() {
  return (
    <>
      <Helmet>
        <title>Join Our Innovative Team | Zwilling Labs Careers</title>
        <meta
          name="description"
          content="Embark on a fulfilling career journey with Zwilling Labs. Thrive in an innovative culture, grow professionally, and contribute to impactful work in Digital Twin technology."
        />
      </Helmet>
      <div className="w-full bg-white">
        <Header className="rounded-bl-[34px] rounded-br-[34px] bg-blue_gray-900" />

        {/* career section */}
        <CareerSection />

        {/* career form section */}
        <CareerFormSection />
        <Footer className="rounded-tl-[34px] rounded-tr-[34px] bg-gradient1 sm:py-[5%]" />
      </div>
    </>
  );
}
